"use client";

import { FC, PropsWithChildren, useContext, useEffect } from "react";
import classNames from "classnames";
import { ModalsContextV2 } from "contexts";
import styles from "./main-content.module.sass";

type Props = {
    variant?: string;
};

const MainContent: FC<PropsWithChildren<Props>> = ({ children, variant }) => {
    const { isAnyModalOpened } = useContext(ModalsContextV2);

    useEffect(() => {
        if (isAnyModalOpened) {
            document.body.classList.add("disable-scroll");
        } else {
            document.body.classList.remove("disable-scroll");
        }
    }, [isAnyModalOpened]);

    return (
        <section
            className={classNames(styles.mainContent, variant && styles[variant])}
            id="mainContent">
            {children}
        </section>
    );
};

export default MainContent;
